goog.provide("shadow.js.shim.module$src$svg$path$path_split_right_svg$default");
shadow.js.shim.module$src$svg$path$path_split_right_svg$default = shadow.js.shim.module$src$svg$path$path_split_right_svg.default;
